import { render, staticRenderFns } from "./AbandonCart.vue?vue&type=template&id=76d5a6cf&scoped=true&"
import script from "./AbandonCart.vue?vue&type=script&lang=js&"
export * from "./AbandonCart.vue?vue&type=script&lang=js&"
import style0 from "./AbandonCart.vue?vue&type=style&index=0&id=76d5a6cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d5a6cf",
  null
  
)

export default component.exports